import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Drawer,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { CircleNotifications } from '@mui/icons-material';
import FormulationPrePostAudi from './FormulationPrePostAudi';

const medicalCenters = ['ForMyers',
  'FortPierce',
  'Immokalee',
  'LakeWorth',
  'Lehigh',
  'Naples',
  'PortSaintLucie'];

const CodingDetails = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [openReferralForm, setOpenReferralForm] = useState(false);
  const [comments, setComments] = useState(modificar.RelatedComments || []);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [newComment, setNewComment] = useState('');
  const timestamp = new Date().toLocaleString(); 
  const date = new Date();
  const monthYear = `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;

  const [form, setForm] = useState({
    MemberID: modificar.MemberID,
    TimeStamp:  modificar.TimeStamp,
    RelatedSystemicBillingReview: modificar.RelatedSystemicBillingReview,
    RelatedComments: modificar.RelatedComments,
    Staff: modificar.Staff,
    MedicalCenter: modificar.MedicalCenter
  });

  const handleAddComment = () => {
    const timestamp = new Date().toLocaleDateString();
    const updatedComments = [...comments, { Timestamp: timestamp, Comments: newComment, StaffName: form.Staff }];
    setComments(updatedComments);
    handleChange('RelatedComments', updatedComments)
    setNewComment('');
    setOpenCommentDialog(false);
  };


  const handleSave = () => {
    onSave(form);
  };

  const SaveNewSystemicBilling  = (newSystemicBilling) => {
    setForm((prevForm) => ({
      ...prevForm,
      RelatedSystemicBillingReview: [
        ...prevForm.RelatedSystemicBillingReview,
        newSystemicBilling
      ]
    }));
  }

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">AHCA Form</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>AHCA</Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Month/Year</strong></Typography></Grid>
          <TextField
            fullWidth
            value={monthYear}
            disabled
          />
          <Grid item width="100%"><Typography><strong>Location</strong> {modificar.InsuranceStatus}</Typography></Grid>
          <TextField
            disabled={!isEditing}
            select
            fullWidth
            value={form.MedicalCenter}
            onChange={e => handleChange('MedicalCenter', e.target.value)}
          >
            {medicalCenters.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Grid item width="100%">
            <Box display="flex" alignItems="center">
              <CircleNotifications sx={{ color: 'green', fontSize: 30, mr: 1 }} />
              <Typography>
                <strong>Related Systemic Billing Reviews</strong>
              </Typography>
            </Box>
          </Grid>
          <Grid item width="100%">
            <Button
              disabled={!isEditing}
              fullWidth
              variant="contained"
              sx={{ backgroundColor: '#bdbdbd', color: 'black', '&:hover': { backgroundColor: '#9e9e9e' }}}
              onClick={() => setOpenReferralForm(true)}
            >
              <Typography sx={{ color: '#117a65' }}>New</Typography>
            </Button>
          </Grid>
          <Grid item width="100%">
            <Box display="flex" alignItems="center">
              <CircleNotifications sx={{ color: 'green', fontSize: 30, mr: 1 }} />
              <Typography>
                <strong>Related Comments</strong>
              </Typography>
            </Box>
          </Grid>
          <Grid item width="100%">
            <Button
              disabled={!isEditing}
              fullWidth
              variant="contained"
              sx={{ backgroundColor: '#bdbdbd', color: 'black', '&:hover': { backgroundColor: '#9e9e9e' }}}
              onClick={() => setOpenCommentDialog(true)}
            >
              <Typography sx={{ color: '#117a65' }}>New</Typography>
            </Button>
          </Grid>
          <TextField
            fullWidth
            value={timestamp}
            disabled
          />
        </Grid>
        {isEditing && (
          <Box display="flex" justifyContent="flex-end" sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
            }}>
            <Button variant="outlined" onClick={() => setIsEditing(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>Save</Button>
          </Box>
        )}
      </Paper>
      <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
          <Box width={650} p={3}>
              <FormulationPrePostAudi
                  //modificar={ selectedPatient?? [] }
                  open={openReferralForm}
                  onClose={() => setOpenReferralForm(false)}
                  onSave={(newReferral) => {
                      SaveNewSystemicBilling(newReferral);
                      setOpenReferralForm(false);
                  }}
              />
          </Box>
      </Drawer>
      {/* Add Comment Dialog */}
      <Dialog open={openCommentDialog} onClose={() => setOpenCommentDialog(false)}>
        <DialogTitle>Add Comment</DialogTitle>
        <DialogContent>
          <TextField
            label="Comment"
            fullWidth
            multiline
            rows={4}
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCommentDialog(false)}>Cancel</Button>
          <Button onClick={handleAddComment} variant="contained">Add</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CodingDetails;
